import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsAndConditionsDialogComponent } from './terms-and-conditions-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [TermsAndConditionsDialogComponent],
  imports: [CommonModule, MatDialogModule, MatIconModule],
  exports: [TermsAndConditionsDialogComponent]
})
export class TermsAndConditionsDialogModule {}
